export default __webpack_public_path__ + "static/media/faqsearch.b7c27641.svg";